<template>
  <ons-page id="reset-password">
    <v-ons-progress-bar indeterminate class="page-progress" v-show="loading"></v-ons-progress-bar>
    <div class="center-box full-height">
      <form action="" class="login-content">
        <div class="form-group">
          <div class="form-row">
            <v-ons-input id="reset-pw" modifier="underbar" type="password" :placeholder="$t('reset_pw.new_pw')" float v-model="password"></v-ons-input>
            <div class="message-error"
              v-for="error in errors.password || []"
            >{{ error }}</div>
          </div>
          <div class="form-row">
            <v-ons-input id="reset-pw-confirm" modifier="underbar" type="password" :placeholder="$t('reset_pw.new_pw_confirm')" float v-model="passwordConfirmation"></v-ons-input>
            <div class="message-error"
              v-for="error in errors.password_confirmation || []"
            >{{ error }}</div>
          </div>
        </div>
        <div class="form-group">
          <div class="form-row justify-row small">
            <div class="main-item">
              <v-ons-button class="reset-submit js-newpage" @click="updatePassword()">{{ $t("reset_pw.reset") }}</v-ons-button>
            </div>
            <div>
              <a class="link-register button--quiet button--small js-newpage" @click.prevent="navigatorResetLogin()" modifier="quiet small" href="">{{ $t("ui.cancel") }}</a>
            </div>
          </div>
        </div>
      </form>
    </div>
  </ons-page>
</template>

<script>
import CurrentUser from '@/models/CurrentUser';

export default {
  name: 'reset-password',
  props: ['resetPasswordToken'],

  data() {
    return {
      password: null,
      passwordConfirmation: null,
      loading: false,
      errors: {},
    };
  },

  methods: {
    updatePassword() {
      this.errors = {};
      let hasError = false;
      // validate
      if (!this.password) {
        this.errors.password = [this.$t("reset_pw.errors.new_pw_empty")];
        hasError = true;
      }
      if (!this.passwordConfirmation) {
        this.errors.password_confirmation = [this.$t("reset_pw.errors.new_pw_confirm_empty")];
        hasError = true;
      }
      if (hasError) { return; }
      if (this.password !== this.passwordConfirmation) {
        this.errors.password_confirmation = [this.$t("reset_pw.errors.pw_not_match")];
        hasError = true;
      }
      if (hasError) { return; }

      let that = this;
      this.loading = true;
      CurrentUser.passwordResetUpdate({
        resetPasswordToken: this.resetPasswordToken,
        password: this.password,
        passwordConfirmation: this.passwordConfirmation,
      }).then(() => {
        this.password = null;
        this.passwordConfirmation = null;
        this.navigatorResetLogin(this.$t("messages.new_pw_set"));
      }).catch((error) => {
        if (error.response && error.response.status === 422 && error.response.data && error.response.data.errors && error.response.data.errors.reset_password_token) {
          that.navigatorResetLogin(that.$t("messages.invalid_reset_pw_token"));
        } else if (error.response && error.response.status === 422) {
          for (var key in error.response.data.errors) {
            that.errors[key] = error.response.data.errors[key];
          }
          that.showCheckErrorsToast();
        } else {
          console.log(error);
          that.showSomethingWrongToast();
        }
      }).finally(() => {
        this.loading = false;
      });
    },
  },

  created() {
    if (!this.resetPasswordToken) {
      this.navigatorResetLogin(this.$t("messages.reset_pw_token_required"));
    }
  },
};
</script>
